import { FC } from 'react';
import { useTrans } from 'base/utils/i18n';
import { IVariant } from 'base/interfaces/product';
import { useStore, observer } from 'base/store';

type IProps = {
    shownVariant: IVariant;
    className?: string;
};

export const ProdSku: FC<IProps> = observer(({ shownVariant, className }) => {
    const { t } = useTrans();
    const { userStore } = useStore();
    const isDropShipping = userStore.isDropShipping();

    return !isDropShipping ? null : (
        <div className={className}>
            {t('web_common_sku_upper')}: {shownVariant.sku}
        </div>
    )
});
